const convertToBool = (value: string | undefined): boolean => value?.toLowerCase() === 'true';

const activationsTabEnabled = false;
export const isActivationsTabEnabled = (): boolean => activationsTabEnabled;

let contractRenewalEditingEnabled = false;
export const isContractRenewalEditingEnabled = (): boolean => contractRenewalEditingEnabled;

interface QueryParams {
    enableActivationsTab?: string;
    enableContractRenewalEditing?: string;
}

const parseQueryString = (queryString: string): QueryParams => {
    const params = new URLSearchParams(queryString);
    return {
        enableActivationsTab: params.get('enableActivationsTab') || undefined,
        enableContractRenewalEditing: params.get('enableContractRenewalEditing') || undefined,
    };
};

export const initToggles = (): void => {
    const searchParams = parseQueryString(window.location.search);
    contractRenewalEditingEnabled = convertToBool(searchParams.enableContractRenewalEditing);
};
